import {
  Box,
  Grid,
  TextField,
  InputAdornment,
  Button,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import * as services from "./../../services/saleng";
import { useState, useEffect } from "react";
import { formatNumber } from "../../utils/formatNumber";
import moment from "moment";
import "moment/locale/th";
import { handleExportExcel } from "./export";

moment.locale("th");

export default function TransformTransactionsTemplate() {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [pickedFilter, setPickedFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [pickupDialogOpen, setPickupDialogOpen] = useState(false);
  const [pickupBatchId, setPickupBatchId] = useState(null);
  const [outputWeight, setProcessedOutputWeight] = useState("");

  const [formData, setFormData] = useState({
    rawMaterialValue: "",
    leafColorIntensity: "",
    rawMaterialWeight: "",
    materialMoisture: "",
    productValue: "",
    productColorIntensity: "",
    outputWeight: "",
    productMoisture: "",
  });
  const [transactionDialogOpen, setTransactionDialogOpen] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);

  const handleViewTransactions = (rows) => {
    const batch = inventory.find((b) => b.id === rows.batch_id);
    if (!batch) return;
    setSelectedTransactions(batch.transactions);
    setTransactionDialogOpen(true);
  };

  const handleCloseTransactionsDialog = () => {
    setTransactionDialogOpen(false);
    setSelectedTransactions([]);
  };
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await services.getBatches();
      console.log(response);
      const data = response?.data ?? [];

      // Map transactions ของแต่ละ batch
      const formattedData = data.map((batch) => {
        const transactions =
          batch.transactions?.map((tx) => ({
            id: tx.id,
            totalWeight: tx.totalWeight,
            weightUsed: tx.weightUsed || 0,
            items: tx.items || [],
            billNumber: tx.billNumber,
            customerName: tx.customerName,
            materialId: tx.materialId,
          })) || [];

        return { ...batch, transactions };
      });

      setInventory(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenPickupDialog = (batch) => {
    setPickupBatchId(batch.batch_id);
    setProcessedOutputWeight(batch.outputWeight ?? batch.totalWeight ?? "");
    setPickupDialogOpen(true);
  };

  const handleClosePickupDialog = () => {
    setPickupDialogOpen(false);
    setPickupBatchId(null);
    setProcessedOutputWeight("");
  };

  async function handleConfirmPickUp() {
    if (!pickupBatchId) return;

    const weight = Number(outputWeight);
    if (!weight || weight <= 0) {
      alert("กรุณากรอกน้ำหนักขาออกให้ถูกต้อง");
      return;
    }

    try {
      await services.updateBatch(
        {
          isPickedUp: true,
          pickedUpAt: new Date().toISOString(),
          outputWeight: weight,
        },
        pickupBatchId
      );
      alert("เบิกสำเร็จ ✅");
      handleClosePickupDialog();
      fetchData();
    } catch (error) {
      console.error("Update failed:", error);
      alert("เบิกไม่สำเร็จ ❌");
    }
  }

  // eslint-disable-next-line no-unused-vars
  async function handlePickUp(id) {
    const confirm = window.confirm("คุณแน่ใจหรือไม่ว่าจะเบิกของรายการนี้?");
    if (!confirm) return;

    try {
      await services.updateBatch(
        {
          isPickedUp: true,
          pickedUpAt: new Date().toISOString(),
        },
        id
      );
      alert("เบิกสำเร็จ ✅");
      fetchData();
    } catch (error) {
      console.error("Update failed:", error);
      alert("เบิกไม่สำเร็จ ❌");
    }
  }
  const handleOpen = (batch_id) => {
    setSelectedBatchId(batch_id);

    // หา transaction ที่เลือก
    const batch = inventory.find((t) => t.id === batch_id);

    if (batch?.length !== 0) {
      setFormData({
        rawMaterialValue: batch.rawMaterialValue ?? "",
        leafColorIntensity: batch.leafColorIntensity ?? "",
        rawMaterialWeight: batch.rawMaterialWeight ?? "",
        materialMoisture: batch.materialMoisture ?? "",
        productValue: batch.productValue ?? "",
        productColorIntensity: batch.productColorIntensity ?? "",
        outputWeight: batch.outputWeight ?? "",
        productMoisture: batch.productMoisture ?? "",
      });
    } else {
      setFormData({
        rawMaterialValue: "",
        leafColorIntensity: "",
        rawMaterialWeight: "",
        materialMoisture: "",
        productValue: "",
        productColorIntensity: "",
        outputWeight: "",
        productMoisture: "",
      });
    }

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedBatchId(null);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!selectedBatchId) return;
    console.log({
      rawMaterialValue: Number(formData.rawMaterialValue),
      leafColorIntensity: Number(formData.leafColorIntensity),
      rawMaterialWeight: Number(formData.rawMaterialWeight),
      materialMoisture: Number(formData.materialMoisture),
      productValue: Number(formData.productValue),
      productColorIntensity: Number(formData.productColorIntensity),
      outputWeight: Number(formData.outputWeight),
      productMoisture: Number(formData.productMoisture)
    })
    try {
      await services.updateBatch(
        {
          rawMaterialValue: Number(formData.rawMaterialValue),
          leafColorIntensity: Number(formData.leafColorIntensity),
          rawMaterialWeight: Number(formData.rawMaterialWeight),
          materialMoisture: Number(formData.materialMoisture),
          productValue: Number(formData.productValue),
          productColorIntensity: Number(formData.productColorIntensity),
          outputWeight: Number(formData.outputWeight),
          productMoisture: Number(formData.productMoisture),
        },
        selectedBatchId
      );
      alert("บันทึกเรียบร้อย");
      handleClose();
      fetchData();
    } catch (err) {
      console.error(err);
      alert("บันทึกไม่สำเร็จ");
    }
  };
  const rows = inventory
    .slice()
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map((t, index) => {
      // ✅ รวมชื่อสินค้าทั้งหมดแล้วเอาเฉพาะอันที่ไม่ซ้ำ
      const productNames = Array.from(
        new Set(
          t.transactions
            ?.flatMap((tx) => tx.items?.map((item) => item.productName) || [])
            .filter(Boolean)
        )
      );
      const productCodes = Array.from(
        new Set(
          t.transactions
            ?.flatMap((tx) => tx.items?.map((item) => item.productCode) || [])
            .filter(Boolean)
        )
      );

      return {
        batch_id: t.id,
        id: t.id,
        batch_no: t.batchNumber,
        billNumber: t.billNumber,
        customerName: t.customerName,
        materialId: t.materialId,
        name: productNames[0] || "-",
        sku: productCodes[0] || "-",
        createdAt: moment(t.createdAt)
          .add(543, "year")
          .format("D MMM YYYY เวลา HH:mm"),
        pickedUpAt: t.pickedUpAt
          ? moment(t.pickedUpAt)
            .add(543, "year")
            .format("D MMM YYYY เวลา HH:mm")
          : "-",
        totalWeight: t.totalWeight,
        outputWeight: t.outputWeight,
        isPickedUp: t.isPickedUp,
        pickedUpCode: t.pickedUpCode || "-",
      };
    });

  const columns = [
    { field: "id", headerName: "No.", flex: 0.3 },
    { field: "batch_no", headerName: "เลขที่ Batch", flex: 0.7 },
    { field: "name", headerName: "ชื่อสินค้า", flex: 1 },
    { field: "sku", headerName: "SKU", flex: 0.7 },
    { field: "createdAt", headerName: "วันที่รับเข้า", flex: 1 },
    { field: "totalWeight", headerName: "น้ำหนัก", type: "number", flex: 0.5 },
    {
      field: "outputWeight",
      headerName: "น้ำหนักขาออก",
      type: "number",
      flex: 0.5,
      valueFormatter: (value) =>
        value == null || value === "" ? "-" : formatNumber(value),
    },
    {
      field: "isPickedUp",
      headerName: "สถานะ",
      flex: 0.5,
      renderCell: (params) => {
        return params.value ? (
          <span style={{ color: "red", fontWeight: "bold" }}>out of stock</span>
        ) : (
          <span style={{ color: "green", fontWeight: "bold" }}>in stock</span>
        );
      },
    },
    { field: "pickedUpAt", headerName: "วันที่เบิก", flex: 1 },
    { field: "pickedUpCode", headerName: "เลขที่ Batch เบิก", flex: 0.7 },

    {
      field: "pick_up",
      headerName: "เบิกของ",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        const isPicked = params.row.isPickedUp;

        return (
          <Button
            variant={isPicked ? "outlined" : "contained"}
            color="primary"
            size="small"
            disabled={isPicked} // ปิดการใช้งานถ้าเบิกแล้ว
            onClick={() => handleOpenPickupDialog(params.row)}
          >
            {isPicked ? "เบิกแล้ว" : "เบิกของ"} {/* ข้อความเปลี่ยน */}
          </Button>
        );
      },
    },
    {
      field: "actions",
      headerName: "ใส่ค่าสาร",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          color="primary"
          onClick={() => handleOpen(params.row.batch_id)}
        >
          <EditIcon />
        </IconButton>
      ),
    },
    {
      field: "view_transactions",
      headerName: "รายละเอียด",
      flex: 0.7,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleViewTransactions(params.row)}
        >
          รายละเอียด
        </Button>
      ),
    },
  ];

  if (loading) return <Box sx={{ p: 2 }}>Loading inventory...</Box>;
  if (error) return <Box sx={{ p: 2, color: "red" }}>Error: {error}</Box>;
  const filteredRows = rows.filter((row) => {
    // Filter by pick status
    if (pickedFilter === "picked" && !row.isPickedUp) return false;
    if (pickedFilter === "notPicked" && row.isPickedUp) return false;

    // Filter by date (createdAt)
    const rowDate = new Date(row.createdAtDate);
    if (startDate && rowDate < new Date(startDate)) return false;
    if (endDate && rowDate > new Date(endDate)) return false;

    return true;
  });
  const labels = {
    rawMaterialValue: "ค่าสารตั้งต้นก่อนออกจากคลัง",
    leafColorIntensity: "ความเข้มอ่อนของสีใบก่อนออกจากคลัง",
    rawMaterialWeight: "น้ำหนักที่ตรงตามมาตรฐาน",
    materialMoisture: "ความชื้น Material",
    productValue: "ค่าสาร Product",
    productColorIntensity: "ความเข้มอ่อนของสี Product",
    outputWeight: "น้ำหนักขาออกหลังแปรรูป",
    productMoisture: "ความชื้น Product",
  };
  return (
    <Box p={2}>
      <AppBreadcrumbs />

      {/* Search & Button */}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="flex-start"
        sx={{ my: 1 }}
      >
        {/* Search */}
        <Grid item xs={12} sm={3} md={3}>
          <TextField
            fullWidth
            placeholder="ค้นหารายละเอียด"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            size="small"
          />
        </Grid>

        {/* สถานะเบิก */}
        <Grid item xs={6} sm={2} md={2}>
          <TextField
            select
            label="สถานะเบิก"
            value={pickedFilter}
            onChange={(e) => setPickedFilter(e.target.value)}
            SelectProps={{ native: true }}
            size="small"
            fullWidth
          >
            <option value="all">ทั้งหมด</option>
            <option value="picked">เบิกแล้ว</option>
            <option value="notPicked">ยังไม่เบิก</option>
          </TextField>
        </Grid>

        {/* วันที่เริ่มต้น */}
        <Grid item xs={6} sm={2} md={2}>
          <TextField
            label="วันที่รับเข้าเริ่มต้น"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            fullWidth
          />
        </Grid>

        {/* วันที่สิ้นสุด */}
        <Grid item xs={6} sm={2} md={2}>
          <TextField
            label="วันที่รับเข้าสิ้นสุด"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            fullWidth
          />
        </Grid>

        {/* ปุ่มรีเฟรช */}
        <Grid item xs={6} sm={1} md={1}>
          <Button
            variant="contained"
            onClick={() => fetchData()}
            size="small"
            fullWidth
          >
            รีเฟรช
          </Button>
        </Grid>
        <Grid item xs={6} sm={1} md={1}>
          <Button
            variant="outlined"
            onClick={() => handleExportExcel(selectedRows, inventory)}
            size="small"
            fullWidth
          >
            Export
          </Button>
        </Grid>
      </Grid>
      {/* DataGrid */}
      <Paper sx={{ mt: 2 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={filteredRows.filter((row) =>
              row.batch_no.toLowerCase().includes(search.toLowerCase())
            )}
            checkboxSelection
            onRowSelectionModelChange={(ids) => setSelectedRows(ids)}
            columns={columns}
            loading={loading}
            disableRowSelectionOnClick
            localeText={{
              noRowsLabel: "ไม่พบข้อมูล",
            }}
          />
        </div>
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle>กรอกข้อมูล Material</DialogTitle>
          <DialogContent dividers>
            {Object.keys(formData)
              .filter((key) => {
                if (
                  [
                    "productValue",
                    "productColorIntensity",
                    "outputWeight",
                    "productMoisture",
                  ].includes(key)
                ) {
                  const selectedRow = inventory.find(
                    (t) => t.id === selectedBatchId
                  );
                  return selectedRow?.isPickedUp;
                }
                return true; // field อื่น ๆ แสดงปกติ
              })
              .map((key) => (
                <TextField
                  key={key}
                  margin="dense"
                  label={labels[key]}
                  name={key}
                  type="number"
                  fullWidth
                  value={formData[key]}
                  onChange={handleChange}
                />
              ))}
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose}>ยกเลิก</Button>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              บันทึก
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={pickupDialogOpen}
          onClose={handleClosePickupDialog}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>กรอกน้ำหนักขาออก</DialogTitle>
          <DialogContent dividers>
            <TextField
              autoFocus
              margin="dense"
              label="น้ำหนักขาออก (kg)"
              type="number"
              fullWidth
              value={outputWeight}
              onChange={(e) => setProcessedOutputWeight(e.target.value)}
              inputProps={{ min: 0, step: 0.01 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClosePickupDialog}>ยกเลิก</Button>
            <Button
              onClick={handleConfirmPickUp}
              variant="contained"
              color="primary"
            >
              เบิกของ
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={transactionDialogOpen}
          onClose={handleCloseTransactionsDialog}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>รายละเอียด ของ batch</DialogTitle>
          <DialogContent dividers>
            {selectedTransactions.length === 0 ? (
              <Box>ไม่พบ transaction</Box>
            ) : (
              <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                  rows={selectedTransactions.map((tx, idx) => ({
                    id: idx + 1,
                    billNumber: (tx.billNumber || "").split("-").pop() || "-",
                    customerName: tx.customerName || "-",
                    materialId: tx.materialId || "-",
                    weightUsed: tx.weightUsed ?? 0,
                  }))}
                  columns={[
                    { field: "billNumber", headerName: "รายการรับเข้า", flex: 1 },
                    {
                      field: "customerName",
                      headerName: "ชื่อซัพพลายเออร์",
                      flex: 1.5,
                    },
                    { field: "materialId", headerName: "Material ID", flex: 1 },
                    {
                      field: "weightUsed",
                      headerName: "น้ำหนัก(กก.)",
                      flex: 1,
                      type: "number",
                    },
                  ]}
                  pageSizeOptions={[5, 10]}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  disableRowSelectionOnClick
                  localeText={{
                    noRowsLabel: "ไม่พบข้อมูล",
                  }}
                />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTransactionsDialog}>ปิด</Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Box>
  );
}
